import { Action } from '@ngrx/store';
import {
  WebhookSubscription,
  WebhookListItem,
  WebhookType,
  WebhookSubjectTypeDropdown
} from 'app/webhooks/model/webhooks.model';
import { Msisdn } from 'app/shared/msisdn/msisdns';

export const GET_ALL_WEBHOOKS = 'GET_ALL_WEBHOOKS';
export const GET_ALL_WEBHOOKS_SUCCESS = 'GET_ALL_WEBHOOKS_SUCCESS';
export const GET_SINGLE_WEBHOOK = 'GET_SINGLE_WEBHOOK';
export const GET_SINGLE_WEBHOOK_SUCCESS = 'GET_SINGLE_WEBHOOK_SUCCESS';
export const GET_WEBHOOK_TYPES = 'GET_WEBHOOK_TYPES';
export const GET_WEBHOOK_TYPES_SUCCESS = 'GET_WEBHOOK_TYPES_SUCCESS';
export const GET_MSISDNS_FOR_WEBHOOKS = 'GET_MSISDNS_FOR_WEBHOOKS';
export const GET_MSISDNS_FOR_WEBHOOKS_SUCCESS = 'GET_MSISDNS_FOR_WEBHOOKS_SUCCESS';
export const SAVE_WEBHOOK = 'SAVE_WEBHOOK';
export const SAVE_WEBHOOK_SUCCESS = 'SAVE_WEBHOOK_SUCCESS';
export const UPDATE_WEBHOOK = 'UPDATE_WEBHOOK';
export const UPDATE_WEBHOOK_SUCCESS = 'UPDATE_WEBHOOK_SUCCESS';
export const CHANGE_WEBHOOK_ACTIVITY = 'CHANGE_WEBHOOK_ACTIVITY';
export const CHANGE_WEBHOOK_ACTIVITY_SUCCESS = 'CHANGE_WEBHOOK_ACTIVITY_SUCCESS';
export const DELETE_WEBHOOK = 'DELETE_WEBHOOK';
export const DELETE_WEBHOOK_SUCCESS = 'DELETE_WEBHOOK_SUCCESS';
export const FILTER_WEBHOOK_LIST = 'FILTER_WEBHOOK_LIST';

export class GetAllWebhooksAction implements Action {
  readonly type = GET_ALL_WEBHOOKS;

  constructor() {}
}

export class GetAllWebhooksSuccessAction implements Action {
  readonly type = GET_ALL_WEBHOOKS_SUCCESS;

  constructor(public payload: WebhookListItem[]) {}
}

export class GetSingleWebhookAction implements Action {
  readonly type = GET_SINGLE_WEBHOOK;

  constructor(public payload: number) {}
}

export class GetSingleWebhookSuccessAction implements Action {
  readonly type = GET_SINGLE_WEBHOOK_SUCCESS;

  constructor(public payload: WebhookSubscription) {}
}

export class GetWebhookTypesAction implements Action {
  readonly type = GET_WEBHOOK_TYPES;

  constructor() {}
}

export class GetWebhookTypesSuccessAction implements Action {
  readonly type = GET_WEBHOOK_TYPES_SUCCESS;

  constructor(public payload: WebhookType[]) {}
}

export class GetMsisdnsForWebhooksAction implements Action {
  readonly type = GET_MSISDNS_FOR_WEBHOOKS;

  constructor() {}
}

export class GetMsisdnsForWebhooksSuccessAction implements Action {
  readonly type = GET_MSISDNS_FOR_WEBHOOKS_SUCCESS;

  constructor(public payload: Msisdn[]) {}
}

export class SaveWebhookAction implements Action {
  readonly type = SAVE_WEBHOOK;

  constructor(public payload: WebhookSubscription) {}
}

export class SaveWebhookSuccessAction implements Action {
  readonly type = SAVE_WEBHOOK_SUCCESS;

  constructor() {}
}

export class UpdateWebhookAction implements Action {
  readonly type = UPDATE_WEBHOOK;

  constructor(public payload: { id: number; webhook: WebhookSubscription }) {}
}

export class UpdateWebhookSuccessAction implements Action {
  readonly type = UPDATE_WEBHOOK_SUCCESS;

  constructor() {}
}

export class ChangeWebhookActivityAction implements Action {
  readonly type = CHANGE_WEBHOOK_ACTIVITY;

  constructor(public payload: { id: number; isActive: boolean }) {}
}

export class ChangeWebhookActivitySuccessAction implements Action {
  readonly type = CHANGE_WEBHOOK_ACTIVITY_SUCCESS;

  constructor() {}
}

export class DeleteWebhookAction implements Action {
  readonly type = DELETE_WEBHOOK;

  constructor(public payload: number) {}
}

export class DeleteWebhookSuccessAction implements Action {
  readonly type = DELETE_WEBHOOK_SUCCESS;

  constructor(public payload: number) {}
}

export class FilterWebhookListAction implements Action {
  readonly type = FILTER_WEBHOOK_LIST;

  constructor(public payload: WebhookSubjectTypeDropdown) {}
}

export type WebhooksAction =
  | GetAllWebhooksAction
  | GetAllWebhooksSuccessAction
  | GetSingleWebhookAction
  | GetSingleWebhookSuccessAction
  | GetWebhookTypesAction
  | GetWebhookTypesSuccessAction
  | GetMsisdnsForWebhooksAction
  | GetMsisdnsForWebhooksSuccessAction
  | SaveWebhookAction
  | SaveWebhookSuccessAction
  | ChangeWebhookActivityAction
  | ChangeWebhookActivitySuccessAction
  | DeleteWebhookAction
  | DeleteWebhookSuccessAction
  | FilterWebhookListAction;
